import axios from "axios";

const api = axios.create({
  baseURL: "https://energy.caredesk360.com",
  // baseURL: "http://localhost:7000",

  withCredentials: true, // 🔥 sends cookie automatically
});

export default api;
